<app-resource-form-card
  [title]="service.title()"
  [resource]="service.resource"
  [detailed]="detailed()"
  [list]="true"
  [createButton]="access()?.branch?.actions?.create">
  <p-table
    [value]="value()"
    [paginator]="true"
    [rows]="5"
    [rowsPerPageOptions]="[5, 10, 20]"
    [scrollable]="true"
    scrollHeight="flex">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th pSortableColumn="name" class="min-w-32">
          Nombre <p-sortIcon field="name" />
        </th>
        @if (detailed()) {
          <th pSortableColumn="description" class="min-w-32">
            Descripción <p-sortIcon field="description" />
          </th>
          @if (access()?.contract?.actions?.read) {
            <th pSortableColumn="contract.name">
              Contrato <p-sortIcon field="contract.name" />
            </th>
          }
        }
        <th class="action">
          Acciones
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-value>
      <tr>
        <td>{{ value.name }}</td>
        @if (detailed()) {
          <td>{{ value.description }}</td>
          @if (access()?.contract?.actions?.read) {
            <td>{{ value.contract.name }}</td>
          }
        }
        <td>
          <div>
            <p-buttonGroup>
              <button
                pButton
                pRipple
                icon="pi pi-info-circle"
                [title]="value.name + ' details'"
                (click)="routesService.details(resource, value._id)"
              ></button>
              @if (access()?.branch?.actions?.update) {
                <button
                  pButton
                  pRipple
                  icon="pi pi-pen-to-square"
                  [title]="value.name + ' edit'"
                  (click)="routesService.edit(resource, value._id)"
                ></button>
              }
              @if (access()?.branch?.actions?.delete) {
                <button
                  pButton
                  pRipple
                  icon="pi pi-trash"
                  [title]="value.name + ' delete'"
                  (click)="routesService.delete(resource, value._id)"
                ></button>
              }
            </p-buttonGroup>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</app-resource-form-card>
